// @ts-nocheck
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Form, Row, Col } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import SaveSubmitButtons from "../../../components/SaveSubmitButtons/SaveSubmitButtons";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import NotificationToast from "../../../components/NotificationToast/NotificationToast";
import api from "../../../services/api";
import { PATHS } from "../../../routes/paths";
import "./EditUsers.css";

const EditUsers = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [loading, setLoading] = useState(true);

  const [userData, setUserData] = useState({
    email: "",
    name: "",
    cnpj: "",
    sigla: "",
    empresa: "",
    departamento: "",
    perfil: "",
    idPerfil: 0,
  });

  useEffect(() => {
    const token = localStorage
      .getItem("token")
      ?.replace(/^"(.*)"$/, "$1")
      .trim();

    const fetchUserById = async () => {
      try {
        const response = await api.get(`/api/usuario/getById/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const user = response.data;
        setUserData({
          email: user.email,
          name: user.nome,
          cnpj: user.cnpj,
          sigla: user.sigla,
          empresa: user.empresa,
          departamento: user.departamento,
          perfil: user.perfil,
          idPerfil: user.idPerfil,
        });

      } catch (error) {
        console.error("❌ Erro ao buscar dados do usuário:", error);
        setToastMessage("Erro ao buscar dados do usuário.");
        setToastType("error");
        setShowToast(true);
        navigate(PATHS.MANAGE_USERS);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchUserById();
  }, [userId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: name === "idPerfil" ? parseInt(value) : value,
    }));
  };

  const handleSave = () => {
    setShowModal(true);
  };

  const handleConfirmSave = async () => {
    try {
      const token = localStorage
        .getItem("token")
        ?.replace(/^"(.*)"$/, "$1")
        .trim();

      const payload = {
        id: parseInt(userId),
        idPerfil: parseInt(userData.idPerfil),
      };


      await api.patch("/api/usuario/updatePerfil", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setToastMessage("Perfil atualizado com sucesso!");
      setToastType("success");
      setShowToast(true);
      setShowModal(false);

      setTimeout(
        () => navigate(PATHS.MANAGE_USERS, { state: { refresh: true } }),
        1500,
      );
    } catch (error) {
      console.error("❌ Erro ao atualizar perfil:", error);
      setToastMessage("Erro ao atualizar o perfil.");
      setToastType("error");
      setShowToast(true);
      setShowModal(false);
    }
  };

  const handleCancel = () => navigate(-1);

  return (
    <Container className="edit-users-container">
      <h1 className="edit-users-title">EDITAR PERFIL DO USUÁRIO</h1>

      {loading ? (
        <PageLoading minHeight="50vh" />
      ) : (
        <>
          <Form className="edit-users-form">
            <Row className="gy-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">E-mail</Form.Label>
                  <Form.Control type="email" value={userData.email} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">Nome</Form.Label>
                  <Form.Control type="text" value={userData.name} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">CNPJ</Form.Label>
                  <Form.Control type="text" value={userData.cnpj} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">Sigla</Form.Label>
                  <Form.Control type="text" value={userData.sigla} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">Empresa</Form.Label>
                  <Form.Control type="text" value={userData.empresa} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">
                    Departamento
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={userData.departamento}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="edit-users-label">Perfil</Form.Label>
                  <Form.Select
                    name="idPerfil"
                    value={userData.idPerfil}
                    onChange={handleChange}
                    aria-label="Perfil"
                  >
                    <option value={2}>Administrador</option>
                    <option value={3}>Analista</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>

          <div className="edit-users-buttons mt-4">
            <SaveSubmitButtons
              onSave={handleSave}
              onCancel={handleCancel}
              showCancel={true}
              showSubmit={false}
              showSave={true}
              showSaveModalOnPage={false}
            />
          </div>
        </>
      )}

      <ConfirmationModal
        isOpen={showModal}
        title="Confirmação"
        message="Deseja realmente alterar o perfil deste usuário?"
        onConfirm={handleConfirmSave}
        onCancel={() => setShowModal(false)}
      />

      <NotificationToast
        show={showToast}
        onClose={() => setShowToast(false)}
        message={toastMessage}
        type={toastType}
      />
    </Container>
  );
};

export default EditUsers;
